import { ProductTemplatesApi } from "api/ProductTemplatesApi";
import { IQueryOptions, QueryKey, useQueryWrapper } from "./api-hooks-common";

type BubbleChartParams = {
  id: number;
  nCount?: number;
  xAttr?: string;
  yAttr?: string;
  zAttr?: string;
  colorAttr?: string;
};

const useBubbleChartData = (
  { id, xAttr, yAttr, zAttr, colorAttr, nCount }: BubbleChartParams,
  options?: IQueryOptions
) =>
  useQueryWrapper(
    [QueryKey.BUBBLE_CHART_DATA, id, xAttr, yAttr, zAttr, colorAttr, nCount],
    () =>
      ProductTemplatesApi.getBubbleChartData({
        id,
        colorAttr,
        nCount,
        xAttr,
        yAttr,
        zAttr,
      }),
    null,
    options
  );

export default useBubbleChartData;
